import { jsx as _jsx } from "react/jsx-runtime";
import { Button as RACButton, composeRenderProps, } from "react-aria-components";
import { twMerge } from "tailwind-merge";
export function Pressable(props) {
    return (_jsx(RACButton, Object.assign({ type: "button" }, props, { className: composeRenderProps(props.className, (className) => twMerge("outline-none cursor-pointer", className)) })));
}
